import { render, staticRenderFns } from "./DoctorRate.vue?vue&type=template&id=31e380ad&"
import script from "./DoctorRate.vue?vue&type=script&lang=js&"
export * from "./DoctorRate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports